import type { ConfigVue } from '../../lib/reservationsApi';

/**
 * Colonnes du tableau du service (maquette L06-02 : « colonnes configurables, ordre, largeur, vues enregistrées »).
 * Le serveur valide la même liste (COLONNES_TABLEAU dans functions/api/modules/reservations.js).
 */
export type IdColonne = 'heure' | 'nom' | 'couverts' | 'table' | 'zone' | 'statut' | 'source' | 'telephone' | 'email' | 'allergies' | 'etiquettes' | 'occasion'
    | 'commentaire_client' | 'notes_internes' | 'service' | 'pris_par' | 'duree';
export type Largeur = 's' | 'm' | 'l';

export const LARGEUR_PX: Record<Largeur, number> = { s: 84, m: 140, l: 230 };
export const LIBELLE_LARGEUR: Record<Largeur, string> = { s: 'Étroite', m: 'Normale', l: 'Large' };

export const CATALOGUE_COLONNES: { id: IdColonne; label: string; court?: string; triable?: boolean; sensible?: boolean }[] = [
    { id: 'heure', label: 'Heure', triable: true },
    { id: 'nom', label: 'Nom', triable: true },
    { id: 'couverts', label: 'Personnes', court: 'Pers.', triable: true },
    { id: 'table', label: 'Table' },
    { id: 'zone', label: 'Salle / zone' },
    { id: 'statut', label: 'Statut', triable: true },
    { id: 'source', label: 'Origine' },
    { id: 'telephone', label: 'Téléphone' },
    { id: 'email', label: 'E-mail' },
    { id: 'allergies', label: 'Allergies', sensible: true },
    { id: 'etiquettes', label: 'Étiquettes' },
    { id: 'occasion', label: 'Occasion' },
    { id: 'commentaire_client', label: 'Commentaire client' },
    { id: 'notes_internes', label: 'Note interne' },
    { id: 'service', label: 'Service' },
    { id: 'pris_par', label: 'Prise par' },
    { id: 'duree', label: 'Fin prévue' },
];
export const colonneDe = (id: string) => CATALOGUE_COLONNES.find((c) => c.id === id);

const col = (id: IdColonne, largeur: Largeur = 'm') => ({ id, largeur });

/** Affichage par défaut : identique à celui de la première tranche (B1). */
export const CONFIG_PAR_DEFAUT: ConfigVue = {
    colonnes: [col('heure', 's'), col('nom', 'l'), col('couverts', 's'), col('table', 's'), col('statut'), col('commentaire_client', 'l'), col('notes_internes', 'l')],
    regroupement: 'aucun', tri: { colonne: 'heure', sens: 'asc' },
};

/** Vues proposées d'office (celles de la maquette) : jamais enregistrées, toujours disponibles, non modifiables. */
export const VUES_PREDEFINIES: { id: string; nom: string; config: ConfigVue }[] = [
    { id: 'p-hotesse', nom: 'Hôtesse', config: CONFIG_PAR_DEFAUT },
    {
        id: 'p-cuisine', nom: 'Cuisine : allergies',
        config: { colonnes: [col('heure', 's'), col('nom', 'l'), col('couverts', 's'), col('allergies', 'l'), col('occasion'), col('table', 's')], regroupement: 'creneau', tri: { colonne: 'heure', sens: 'asc' } },
    },
    {
        id: 'p-direction', nom: 'Direction',
        config: { colonnes: [col('heure', 's'), col('nom', 'l'), col('couverts', 's'), col('table', 's'), col('statut'), col('source'), col('telephone'), col('etiquettes', 'l'), col('commentaire_client', 'l'), col('notes_internes', 'l')], regroupement: 'aucun', tri: { colonne: 'heure', sens: 'asc' } },
    },
];

export const memeConfig = (a: ConfigVue, b: ConfigVue) => JSON.stringify(a) === JSON.stringify(b);

/** Plancher d'un quart d'heure : « 19:07 » → « 19:00 » (regroupement par créneau). */
export const creneauDe = (heure: string) => `${heure.slice(0, 2)}:${String(Math.floor(Number(heure.slice(3, 5)) / 15) * 15).padStart(2, '0')}`;
